import type React from "react";

declare global {
	namespace JSX {
		interface IntrinsicElements {
			"veritree-contextualization": React.DetailedHTMLProps<
				React.HTMLAttributes<HTMLElement> & {
					"org-id"?: string;
					type?: "land" | "workdays" | "carbon" | "food-security";
					context?: string;
					theme?: "light" | "dark" | "system";
					"bg-color"?: string;
					"bg-color-dark"?: string;
					"icon-bg-color"?: string;
					"icon-bg-color-dark"?: string;
					"icon-fg-color"?: string;
					"icon-fg-color-dark"?: string;
					"value-color"?: string;
					"value-color-dark"?: string;
					shadow?: string;
					"shadow-dark"?: string;
					image?: string;
					icon?: string;
					"api-version"?: string;
					"api-url"?: string;
					stats?: string;
					"forest-types"?: string;
				},
				HTMLElement
			>;
		}
	}
}

interface VeritreeCardProps {
	type: "land" | "workdays" | "carbon" | "food-security";
	context?:
		| "tennis-court"
		| "studio-apartment"
		| "playground"
		| "sydney-opera-house"
		| "melbourne-cricket-ground"
		| "cars"
		| "sydney-perth-flight";
	theme?: "light" | "dark" | "system";
	bgColor?: string;
	bgColorDark?: string;
	iconBgColor?: string;
	iconBgColorDark?: string;
	iconFgColor?: string;
	iconFgColorDark?: string;
	valueColor?: string;
	valueColorDark?: string;
	shadow?: string;
	shadowDark?: string;
	image?: string;
	icon?: string;
}

const VeritreeCard: React.FC<VeritreeCardProps> = ({
	type,
	context,
	theme,
	bgColor,
	bgColorDark,
	iconBgColor,
	iconBgColorDark,
	iconFgColor,
	iconFgColorDark,
	valueColor,
	valueColorDark,
	shadow,
	shadowDark,
	image,
	icon,
}) => {
	return (
		<veritree-contextualization
			org-id="XKWNJZM4TN3JZ3Z3"
			type={type}
			context={context}
			theme={theme}
			bg-color={bgColor}
			bg-color-dark={bgColorDark}
			icon-bg-color={iconBgColor || "#FFAA98"}
			icon-bg-color-dark={iconBgColorDark}
			icon-fg-color={iconFgColor || "#121252"}
			icon-fg-color-dark={iconFgColorDark}
			value-color={valueColor || "#121252"}
			value-color-dark={valueColorDark}
			shadow={shadow}
			shadow-dark={shadowDark}
			image={image}
			icon={icon}
		/>
	);
};

export default VeritreeCard;
